import { render } from "./ClubTournamentMatchList.vue?vue&type=template&id=23c33604&ts=true"
import script from "./ClubTournamentMatchList.vue?vue&type=script&lang=ts"
export * from "./ClubTournamentMatchList.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__